export const WINDOW_DID_SCROLL = 'WINDOW_DID_SCROLL'
export const WINDOW_WAS_RESIZED = 'WINDOW_WAS_RESIZED'
export const BREAKPOINT_CHANGE = 'BREAKPOINT_CHANGE'
